import _intersection from 'lodash/intersection';

const getFeaturedImage = (imagePool, cruise) => {
	const cruiseImages = cruise.masterSailing.itinerary.media.images;
	const itineraryImagePool = imagePool?.itineraryImages.find(item => JSON.stringify(item) === JSON.stringify(cruiseImages));

	if (itineraryImagePool) {
		const itineraryImages = itineraryImagePool.map((item) => item.path);
		const pastImages = imagePool.displayedImages.slice(itineraryImages.length * -1);
		const coincidence = _intersection(pastImages, itineraryImages);

		const availableImages = itineraryImages.filter((value) => !coincidence.includes(value));

		let image = '';
		if (!availableImages.length) {
			image = pastImages[0];
		} else {
			image = availableImages[0];
		}

		imagePool.displayedImages.push(image);
		return { path: image };
	}
	return { path: null };
};

export default getFeaturedImage;
